import { render, staticRenderFns } from "./historyPlan.vue?vue&type=template&id=5aae8aae&scoped=true"
import script from "./historyPlan.vue?vue&type=script&lang=js"
export * from "./historyPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae8aae",
  null
  
)

export default component.exports